import React from 'react';
import Button from './ui/Button';
import Icon from './ui/Icon';
import { RevealGroup } from './ui/Reveal';
import SectionHeading from './ui/SectionHeading';
import actionHref from '../lib/links';
import { getInvolved } from '../data/content';

export default function GetInvolved() {
  return (
    <section id="get-involved" className="bg-cream-200 py-24 sm:py-32">
      <div className="shell">
        <SectionHeading index="09" label="Get Involved" title="Get Involved" lead={getInvolved.intro} />

        <RevealGroup
          as="ul"
          variant="up"
          stagger={110}
          delay={140}
          className="mt-16 grid gap-7 sm:grid-cols-2 lg:grid-cols-4"
        >
          {getInvolved.cards.map((card) => (
            <li
              key={card.title}
              className="group relative flex flex-col overflow-hidden bg-white/75 p-8 shadow-card transition-all duration-500 ease-out-expo hover:-translate-y-1.5 hover:shadow-card-hover"
            >
              {/* A gold hairline that draws across the top of the card on hover. */}
              <span
                className="absolute inset-x-0 top-0 h-[3px] origin-left scale-x-0 bg-gold transition-transform duration-500 ease-out-expo group-hover:scale-x-100"
                aria-hidden="true"
              />
              <Icon
                name={card.icon}
                className="h-10 w-10 text-ink transition-transform duration-500 ease-out-expo group-hover:-translate-y-0.5 group-hover:scale-110"
                strokeWidth={1.8}
              />
              <h3 className="mt-6 font-display text-base font-semibold uppercase tracking-[0.16em] text-ink">
                {card.title}
              </h3>
              <p className="mt-4 flex-1 text-sm leading-relaxed text-ink/70">{card.body}</p>
              <Button href={actionHref(card.cta.action)} variant={card.cta.variant} className="mt-7 self-start">
                {card.cta.label}
              </Button>
            </li>
          ))}
        </RevealGroup>
      </div>
    </section>
  );
}
